import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { compose, lifecycle, withHandlers, withState } from "recompose";
import { Message } from "semantic-ui-react";
import { CaseStatusDetails, SearchForm } from "./components";
import { CaseStatusesApiService, OrganizationsApiService } from "./../../api";
import { CaseStatusesStats } from "./components/CaseStatusesStats";

const CaseStatuses = ({
  caseNotFound,
  caseStatusFields,
  onClear,
  onSearch,
  organization,
}) => {
  return (
    <Fragment>
      <Message
        content="Wyszukiwanie statusu sprawy po numerze identyfikacyjnym nadanym w EZD lub w portalu dla złożonego pisma"
        icon="inbox"
        info
      />
      {organization.showStats && (
        <CaseStatusesStats caseStatusesStats={organization.caseStatusesStats} />
      )}
      <SearchForm onSubmit={onSearch} />
      {caseNotFound && (
        <Message
          content="Podana sprawa nie została znaleziona"
          icon="warning sign"
          negative
          onDismiss={onClear}
        />
      )}
      {caseStatusFields && (
        <CaseStatusDetails caseStatusFields={caseStatusFields} />
      )}
    </Fragment>
  );
};

CaseStatuses.propTypes = {
  organization: PropTypes.object,
  caseNotFound: PropTypes.bool,
  caseStatusFields: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })
  ),
  onClear: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
};

const enhance = compose(
  withState("availableFields", "setAvailableFields", []),
  withState("caseNotFound", "setCaseNotFound", false),
  withState("caseStatusFields", "setCaseStatusFields"),
  withHandlers({
    onClear: ({ setCaseNotFound, setCaseStatusFields }) => () => {
      setCaseNotFound(false);
      setCaseStatusFields();
    },
    onSearch: ({
      availableFields,
      match,
      setCaseNotFound,
      setCaseStatusFields,
    }) => async (model) => {
      try {
        const { organization: organizationId } = match.params;
        const { "case-id": caseId } = model;
        const caseStatus = await OrganizationsApiService.getCaseStatus(
          organizationId,
          caseId
        );
        const caseStatusFields = availableFields
          .map(({ name, desc }) => ({
            label: desc,
            value: caseStatus[name],
          }))
          .filter(({ value }) => value !== null && value !== undefined);
        setCaseNotFound(false);
        setCaseStatusFields(caseStatusFields);
      } catch (error) {
        setCaseNotFound(true);
        setCaseStatusFields();
      }
    },
  }),
  lifecycle({
    async componentDidMount() {
      const availableFields = await CaseStatusesApiService.getAvailableFields();
      this.props.setAvailableFields(availableFields);
    },
  })
);

export { CaseStatuses, enhance };
export default enhance(CaseStatuses);



// WEBPACK FOOTER //
// ./src/containers/case-statuses/CaseStatuses.js